import { render, staticRenderFns } from "./tacticsUpdate.vue?vue&type=template&id=f883fd44&scoped=true"
import script from "./tacticsUpdate.vue?vue&type=script&lang=js"
export * from "./tacticsUpdate.vue?vue&type=script&lang=js"
import style0 from "./tacticsUpdate.vue?vue&type=style&index=0&id=f883fd44&prod&lang=less"
import style1 from "./tacticsUpdate.vue?vue&type=style&index=1&id=f883fd44&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f883fd44",
  null
  
)

export default component.exports